import React from 'react';
import PropTypes from 'prop-types';
import CrewModal from './CrewModal';

const CreateCrewModal = ({ isOpen, newCrew, trainingGroups, onClose, onCrewChange, onSubmit }) => {
  // Don't render if modal is not open or newCrew is null
  if (!isOpen || !newCrew) return null;

  return (
    <CrewModal
      isOpen={isOpen}
      crew={newCrew}
      trainingGroups={trainingGroups}
      onClose={onClose}
      onCrewChange={onCrewChange}
      onSubmit={onSubmit}
      mode="create"
    />
  );
};

CreateCrewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  newCrew: PropTypes.object,
  trainingGroups: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onCrewChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CreateCrewModal;
